export default __webpack_public_path__ + "static/media/tilefloor.25430237.jpg";